import { ExtractRecordPaths, RaRecord, useFieldValue } from 'ra-core';

type Props<R extends RaRecord> = {
  source: ExtractRecordPaths<R>;
  listType?: 'comma' | 'tag' | 'listItem';
  label?: string;
  className?: string;
};

function ListField<R extends RaRecord>({
  source,
  listType = 'comma',
  className,
}: Props<R>) {
  const value: string[] | string | undefined = useFieldValue({ source });

  if (!value) return null;

  if (Array.isArray(value)) {
    if (listType === 'listItem') {
      return (
        <ul className="list-disc list-inside space-y-0.5">
          {value.map(item => (
            <li key={item} className="text-sm text-muted-foreground">
              {item}
            </li>
          ))}
        </ul>
      );
    }
    return (
      <span className={`text-sm text-muted-foreground ${className ?? ''}`}>
        {value.join(', ')}
      </span>
    );
  }

  return (
    <span className={`text-sm text-muted-foreground ${className ?? ''}`}>
      {value}
    </span>
  );
}

export default ListField;
